import { Medicament } from "./medicament";
import { Consultation } from "./consultation";

export class Actes {
        acte_id:any;
        acte_type:any;
	    acte_type_dent:any;
        acte_dent : any;
        acte_diagnostic:any;
        acte_reference:any;
        acte_autre : any;
        //acte_type_dent:any;
         acte_etat : any;
        consultation_id : number;

        

    constructor(){
           
    }
}
